export function getPercentageOfMaxHp(maxHp, percentage) {
  return Math.round( maxHp * (percentage * 0.01) );
}